import {nnTrim} from "./util";

/**
 * Mother of all classes of Tumbo
 * @abstract
 */
class Base{
    constructor() {
        this.properties = {};
    }

    /**
     * Set a property
     * Has no semantics but can be useful from the outside
     * @param code {string} The id of the property
     * @param value {*} The value of the property
     * @return {Base} This UI element
     */
    set(code, value) {
        this.properties[code] = value;
        return this;
    }

    /**
     * Get a property value
     * Has no semantics but can be useful from the outside
     * @param code {string} The id of the property
     * @return {*}
     */
    get(code) {
        return this.properties[code];
    }

    getClassName(){
        return "Base";
    }

    /**
     * This object's class name
     * @return {string}
     */
    getClass() {
        return this.__proto__.constructor.name;
    }

    /**
     * Log a debug message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */
    logDebug(msg, obj = undefined) {
        tumbo.LOGGER.logDebug(msg ? ("[" + this.getLogId() + "]\t" + msg) : ("[" + this.getLogId() + "]"), obj);
    }

    /**
     * Log an info message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */
    logInfo(msg, obj = undefined) {
        tumbo.LOGGER.logInfo(msg ? ("[" + this.getLogId() + "]\t" + msg) : ("[" + this.getLogId() + "]"), obj);
    }

    /**
     * Log an error message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */

    logError(msg, obj = undefined) {
        tumbo.LOGGER.logError(msg ? ("[" + this.getLogId() + "]\t" + msg) : ("[" + this.getLogId() + "]"), obj);
    }

    /**
     * An ID token to use for logging
     * @return {string}
     */
    getLogId() {
        return nnTrim(this.getClassName(), this.getClass());
    }
}

export {Base}